import * as React from 'react';
import { Container } from 'typescript-ioc';
import { injectIntl, IntlShape, useIntl } from 'react-intl';
import classNames from 'classnames';
import { IRouter } from '../../../../../infrastructure/router';
import { Link } from '../../../../../infrastructure/components/router-extensions';
import { connectEventsVM } from '../../../events.context';
import { isPathIncludesInCurrentRoute } from '../../../../../infrastructure/utils/common.utils';
import './navigation.scss';
import { getEventNavigationLinks, getEventTrackerLinks, getZoomNavigationLinks, INavigationLink } from '../../../../../constants/navigation.constants';

interface IProps {
    links: INavigationLink[];
}

interface IEventNavigationProps {
    routeParams: IRouteParams;
    intl: IntlShape;
}

interface IRouteParams {
    accountId: string;
    eventId: string;
}

const Navigation = (props: IProps) => {
    const routingService = Container.get(IRouter);
    const route = routingService.router.getState();

    return (
        <div className='navigation-row'>
            {props.links.filter(el => !el.isHidden).map(({ label, routeEnum, routeParams }) => {
                const routeClass = classNames(
                    'navigation-row__button',
                    { 'navigation-row__button--active': isPathIncludesInCurrentRoute(routeEnum, route) }
                );

                return (
                    <Link
                        key={label}
                        routeEnum={routeEnum}
                        routeParams={routeParams}
                        className={routeClass}
                    >
                        {label}
                    </Link>
                );
            })}
        </div>
    );
};

const ResourcesNavigation = injectIntl(({ intl }: { intl: IntlShape }) => {
    const links = getZoomNavigationLinks(intl);

    return <Navigation links={links} />;
});

const EventNavigation = (props: IEventNavigationProps) => {
    const { routeParams, intl } = props;
    const links = getEventNavigationLinks({ routeParams: routeParams }, intl);

    return <Navigation links={links} />;
};

const EventTrackerNavigation = injectIntl(({ intl }: { intl: IntlShape }) => {
    const links = getEventTrackerLinks(intl);

    return <Navigation links={links} />;
});

const ManageEventNavigation = connectEventsVM<IEventNavigationProps>(EventNavigation, vm => {
    const intl = useIntl();
    const accountIdString = vm.getAccountId().toString(10);
    const eventIdString = vm.getEventId().toString(10);

    const routeParams = {
        accountId: accountIdString,
        eventId: eventIdString,
    };

    return {
        routeParams: routeParams,
        intl: intl,
    };
});

export { ManageEventNavigation, ResourcesNavigation, EventNavigation, EventTrackerNavigation, Navigation };
